import { render, staticRenderFns } from "./get_delivery.vue?vue&type=template&id=15f94ea2&scoped=true"
import script from "./get_delivery.vue?vue&type=script&lang=js"
export * from "./get_delivery.vue?vue&type=script&lang=js"
import style0 from "./get_delivery.vue?vue&type=style&index=0&id=15f94ea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f94ea2",
  null
  
)

export default component.exports